import { useState, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { toast } from 'react-toastify';
import appConfig from '../../../../config/app-config';
import tokenAwareFetcher from '../../../../utils/tokenAwareFetcher';

const COMM_API = appConfig.apis.communicationApiEnv;
const commFetcher = tokenAwareFetcher(COMM_API.address, COMM_API.key);

const CONTACT_STATUSES = [
    { value: 'NONE', label: 'Não iniciado', color: 'bg-gray-500' },
    { value: 'FAST', label: 'Rápido', color: 'bg-green-500' },
    { value: 'WAITING', label: 'Aguardando retorno', color: 'bg-purple-500' },
    { value: 'MODERATELY_FAST', label: 'Moderadamente rápido', color: 'bg-yellow-500' },
    { value: 'LONG_TIME', label: 'Demora responder', color: 'bg-orange-500' },
    { value: 'NO_RESPOND', label: 'Não responde', color: 'bg-red-500' },
];

interface Props {
    contactId: string;
    status: string;
    onStatusChange?: (newStatus: string) => void;
}

export default function ContactStatusSelector({ contactId, status, onStatusChange }: Props) {
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(status);

    useEffect(() => { setCurrent(status); }, [status]);

    const handleChange = async (newStatus: string) => {
        setOpen(false);
        try {
            const res = await commFetcher.put(`/contacts/${contactId}`, { status: newStatus });
            if (!res.ok) throw new Error('Failed');
            setCurrent(newStatus);
            onStatusChange?.(newStatus);
        } catch {
            toast.error('Erro ao atualizar status do contato');
        }
    };

    const currentItem = CONTACT_STATUSES.find(s => s.value === current) || CONTACT_STATUSES[0];

    return (
        <div className="relative">
            <button onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
                className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] hover:bg-gray-100 dark:hover:bg-slate-700">
                <span className={`w-2 h-2 rounded-full ${currentItem.color}`} />
                <span className="text-gray-500">{currentItem.label}</span>
                <FiChevronDown size={9} />
            </button>
            {open && (
                <div className="absolute left-0 top-full mt-1 bg-white dark:bg-slate-700 border border-gray-200 dark:border-slate-600 rounded shadow-lg z-50 min-w-[200px]">
                    {CONTACT_STATUSES.map(s => (
                        <button key={s.value} onClick={() => handleChange(s.value)}
                            className={`w-full text-left px-3 py-1.5 text-xs hover:bg-gray-50 dark:hover:bg-slate-600 flex items-center gap-2 whitespace-nowrap ${current === s.value ? 'font-medium' : ''}`}>
                            <span className={`w-2 h-2 rounded-full ${s.color}`} />
                            {s.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
